import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as DownIcon } from "../../assets/icons/down.svg";
import styles from "../../styles/components/DropdownSelect.module.css";

function cx(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DropdownSelect = ({
  title,
  items = [],
  selectedItem,
  onChange,
  labelKey = "name",
  valueKey = "id",
  placeholder = "Seleccionar...",
  isEditing = false,
  disabled = false,
  className,
  error,
}) => {
  const [open, setOpen] = useState(false);
  const wrapperRef = useRef(null);

  useEffect(() => {
    if (!isEditing || disabled) {
      setOpen(false);
    }
  }, [isEditing, disabled]);

  useEffect(() => {
    function handleClickOutside(e) {
      if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
        setOpen(false);
      }
    }

    if (open) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [open]);

  const handleToggle = (e) => {
    e.stopPropagation();
    if (!isEditing || disabled) return;
    setOpen((prev) => !prev);
  };

  const handleSelect = (e, item) => {
    e.stopPropagation();
    onChange?.(item);
    setOpen(false);
  };

  return (
    <div ref={wrapperRef} className={cx(styles.wrapper, className)}>
      {title ? <div className={styles.label}>{title}</div> : null}

      <button
        type="button"
        className={cx(
          styles.container,
          open && styles.open,
          disabled && styles.disabled,
          error && styles.error,
        )}
        onClick={handleToggle}
      >
        <div className={styles.value}>
          {selectedItem ? (
            <span>{selectedItem[labelKey]}</span>
          ) : (
            <span className={styles.placeholder}>{placeholder}</span>
          )}
        </div>

        <DownIcon className={cx(styles.chevron, open && styles.chevronUp)} />
      </button>

      {typeof error === "string" && error ? (
        <div className={styles.errorText}>{error}</div>
      ) : null}

      {open && (
        <div
          className={styles.menu}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}
        >
          {items.length === 0 ? (
            <div className={styles.empty}>No hay opciones</div>
          ) : (
            items.map((item) => (
              <button
                key={item[valueKey] ?? item.id ?? item.value}
                type="button"
                className={styles.option}
                onClick={(e) => handleSelect(e, item)}
              >
                {item[labelKey]}
              </button>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default DropdownSelect;
